import React, { useEffect, useState } from 'react';
import { Phone, PhoneOff, User, Settings } from 'lucide-react';
import { useSIP } from '../../context/SIPContext';
import DeviceSelector from './AudioDeviceSelector';

const AUTO_ANSWER_DELAY = localStorage.getItem("autoAnswerInterval"); // seconds

const IncomingCallPopup = ({ caller, callerNumber, onAnswer, onReject }) => {
    const [showDevices, setShowDevices] = useState(false);
    const { audioDevices, selectedDevices, changeMicrophone, changeSpeaker } = useSIP();

    

    const autoAnswerEnabled = localStorage.getItem("autoAnswer") === "true";
    const [countdown, setCountdown] = useState(AUTO_ANSWER_DELAY);

    useEffect(() => {
        if (!autoAnswerEnabled) return;

        // Countdown tick every second
        const interval = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        // Auto-answer after the delay
        const timer = setTimeout(() => {
            onAnswer();
        }, AUTO_ANSWER_DELAY * 1000);

        return () => {
            clearTimeout(timer);
            clearInterval(interval);
        };
    }, [autoAnswerEnabled, onAnswer]);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center z-[9999] animate-fadeIn">
            <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm w-full mx-4">
                <div className="flex flex-col items-center space-y-4">
                    {/* Caller Avatar */}
                    <div className="w-24 h-24 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-white text-4xl font-semibold shadow-lg">
                        {caller ? caller.charAt(0).toUpperCase() : <User size={48} />}
                    </div>

                    {/* Caller Name */}
                    <div className="text-2xl font-semibold text-gray-800">
                        {caller || 'Unknown Caller'}
                    </div>
                    <div className="text-2xl font-semibold text-gray-800">
                        {callerNumber || 'Unknown Caller'}
                    </div>

                    {/* Call Type */}
                    <div className="flex items-center gap-2 text-gray-600">
                        <Phone size={16} />
                        <span>Incoming Audio Call</span>
                    </div>

                    {/* Device Settings Toggle Button */}
                    <button
                        className="text-sm text-blue-600 hover:text-blue-700 flex items-center gap-1 transition-colors"
                        onClick={() => setShowDevices(!showDevices)}
                    >
                        <Settings size={14} />
                        {showDevices ? 'Hide' : 'Audio'} Settings
                    </button>
                    {/* <span
                        style={{
                            border: '1px solid orange',
                            borderRadius: '10px',
                            padding: '4px 8px',
                            color: 'orange',
                            fontSize: '12px',
                            fontWeight: '600'
                        }}
                    >
                        Refreshing disconnects the current call.
                    </span> */}

                    {/* Device Selector */}
                    {showDevices && (
                        <div className="w-full">
                            <DeviceSelector
                                audioDevices={audioDevices}
                                selectedDevices={selectedDevices}
                                onMicrophoneChange={changeMicrophone}
                                onSpeakerChange={changeSpeaker}
                            />
                        </div>
                    )}

                    {/* Action Buttons */}
                    <div className="flex gap-6 pt-4">
                        {/* Reject Button */}
                        <button
                            className="w-16 h-16 rounded-full bg-red-500 hover:bg-red-600 active:bg-red-700 flex items-center justify-center text-white shadow-lg transition-all duration-200 transform hover:scale-105"
                            onClick={onReject}
                            title="Reject Call"
                        >
                            <PhoneOff size={32} />
                        </button>

                        {/* Answer Button */}
                        <button
                            className={`w-16 h-16 rounded-full bg-green-500 hover:bg-green-600 active:bg-green-700 flex items-center justify-center text-white shadow-lg transition-all duration-200 transform hover:scale-105 ${autoAnswerEnabled ? '' : 'animate-pulse'
                                }`}
                            onClick={onAnswer}
                            title="Answer Call"
                        >
                            <Phone size={32} />
                        </button>
                    </div>
                </div>

                {/* Auto-answer loader (inside the card, below the buttons) */}
                {autoAnswerEnabled && countdown > 0 && (
                    <div className="flex flex-col items-center justify-center mt-6">
                        <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                        <p className="mt-2 text-sm text-gray-600">
                            Auto answering in {countdown}s...
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default IncomingCallPopup;